import highDemandImage from './images/lightning.png';
import lowDemandImage from './images/percent.png';

export default ['$scope', 'deviceService', function($scope, deviceService) {
  $scope.isMobile = deviceService.isMobile;
  const highDemandTitle = $scope.isMobile
  ? 'Район с высоким спросом'
  : 'Это район с высоким спросом и конкуренцией';

  $scope.isHighDemand = this.demandCoefficient > 1;

  const lowDemandTitle = 'На подобные объекты действует скидка';

  $scope.demandTitle = $scope.isHighDemand ? highDemandTitle : lowDemandTitle;
  $scope.lightningImg = $scope.isHighDemand ? highDemandImage : lowDemandImage;

  $scope.demandContentTitle = $scope.isHighDemand
    ? 'Стоимость размещения увеличена.'
      : $scope.isMobile
      ? 'Не упустите выгодное предложение!'
      : '';

  $scope.demandContent = $scope.isHighDemand
    ? 'По данным нашего аналитического центра, в этом районе'
    : 'Опубликуйте все доступные площади, чтобы сдать их быстрее';
}];
